import React, { Component } from 'react';
import { connect } from 'react-redux';
import { numberRegx, imgStoragePath } from '../../../../constants';
import { UPDATE_SIMULATION_FIELDS } from '../actions';
class GrpPlainField extends Component{
  constructor(props){
    super(props);
    this.state = {
      fieldObj:{},
      invalidData: false
    };
  }
  componentDidMount(){
    this.updateFieldState(this.props);
  }
  componentWillReceiveProps(nextProps){
    this.updateFieldState(nextProps);
  }
  updateFieldState = (obj) => {
    this.setState(prevState => ({
      ...prevState,
      fieldObj: {
        ...prevState.fieldObj,
        metrixType: obj.metrixType,
        eventIndex: obj.eventIndex,
        programType: obj.programType,
        keyParam: obj.keyParam,
        value: obj.value
      }
    }));
  }
  updateField = (e) => {
    const value = e.target.value
    this.setState(prevState => ({
      ...prevState,
      fieldObj: {
        ...prevState.fieldObj,
        value: value
      }
    }));
  }
  updateMRSimilation = () => {
    if(numberRegx.test(this.state.fieldObj.value)){
      this.props.updateSimulationField({
        metrixType: this.state.fieldObj.metrixType,
        programType: this.state.fieldObj.programType,
        eventIndex: this.state.fieldObj.eventIndex,
        keyParam: this.state.fieldObj.keyParam,
        value: this.state.fieldObj.value
      });
      this.setState({
        invalidData: false
      })
    }else{
      this.setState(prevState => ({
        ...prevState,
        fieldObj: {
          ...prevState.fieldObj,
          value: this.props.value
        },
        invalidData: true
      }))
    }

  }
  render(){
    const { simulationType, newvalue, value, metrixType, programType, eventIndex } = this.props;
    if(simulationType == 0){
      return(
        <div>
          <h6 className="para-ui">{value}</h6>
        </div>
      )
    } else if(simulationType == 1){
      return(
        <div className="editable-field">
          <input
            type="text"
            value={this.state.fieldObj.value}
            onChange={this.updateField}
            onBlur={this.updateMRSimilation}
          />
          <span className="field-edit-icn">
            <img src={imgStoragePath+"edit-field.png"} alt="ic" />
          </span>
          {this.state.invalidData ? <p className="mr-error-field">Invalid Value</p>:null}
        </div>
      )
    }else if(simulationType == 2){
      return(
        <div className="override-value">
          {
            value == newvalue ?
            <h6>
                {value}
            </h6>:
            <div>
              <h6 className="changed-value">
                  {newvalue}
              </h6>
              <p className="old-value">
                  {value}
              </p>
            </div>
          }
        </div>
      )
    }else{
      return null
    }
  }
}
const mapStateToProps = state => ({
  simulationType: state.MRFinanceGraphReducer.simulationType
});
const mapDispatchToProps = dispatch => {
  return {
    updateSimulationField: (data) => dispatch({
      type: UPDATE_SIMULATION_FIELDS,
      payload: data
    })
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(GrpPlainField)
